import type { NavigateOptions, RegisteredRouter } from "@tanstack/react-router";

export const ESTIMATE_CARRY_FORWARD_KEY = "crs_estimate_carry_forward";

export type EstimateCarryForward = {
  name?: string;
  email?: string;
  phone?: string;
  postcode?: string;
  sourcePage?: string;
};

export function isEstimateCarryForward(value: unknown): value is EstimateCarryForward {
  if (!value || typeof value !== "object") return false;
  const v = value as Record<string, unknown>;
  return (
    (v.name === undefined || typeof v.name === "string") &&
    (v.email === undefined || typeof v.email === "string") &&
    (v.phone === undefined || typeof v.phone === "string") &&
    (v.postcode === undefined || typeof v.postcode === "string") &&
    (v.sourcePage === undefined || typeof v.sourcePage === "string")
  );
}

export function storeEstimateCarryForward(data: EstimateCarryForward) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(ESTIMATE_CARRY_FORWARD_KEY, JSON.stringify(data));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readEstimateCarryForward(): EstimateCarryForward | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(ESTIMATE_CARRY_FORWARD_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return isEstimateCarryForward(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function clearEstimateCarryForward() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(ESTIMATE_CARRY_FORWARD_KEY);
  } catch {
    /* ignore */
  }
}

/** Persist contact details then navigate without putting them in the URL. */
export function navigateToCompleteYourEstimate(
  navigate: (opts: NavigateOptions<RegisteredRouter>) => unknown,
  contact: EstimateCarryForward,
) {
  storeEstimateCarryForward(contact);
  return navigate({
    to: "/complete-your-estimate",
    state: contact,
  } as NavigateOptions<RegisteredRouter>);
}
